<template>
  <div class="wrap1">
    <h1 class="common-title">
      <span> <i class="el-icon-arrow-left icon" @click="handlerBack"></i>{{ $t('pay_slip_21') }} </span>
    </h1>
    <div class="wrap1-box">
      <div class="info">
        <!-- 1、2 计算中 -->
        <template v-if="payState.state">
          <div class="icon-wraing icon"><div class="sp sp-3balls"></div></div>
          <h2>{{ payslipInfo.name }} {{ $t('pay_slip_39') }}</h2>
        </template>
        <!-- 0 计算成功 -->
        <template v-else>
          <div class="el-icon-success icon"></div>
          <h2>{{ payslipInfo.name }} {{ $t('pay_slip_38') }}</h2>
        </template>
        <div class="info-con">
          <div class="info-con-item">
            <p>{{ $t('pay_slip_22') }}</p>
            <span>{{ Number(payslipInfo.send_count) | ThousandSeparator }}</span>
          </div>
          <div class="info-con-item center">
            <p>{{ $t('pay_slip_23') }}</p>
            <span v-if="payslipInfo.send_success_count">{{
              Number(payslipInfo.send_success_count) | ThousandSeparator
            }}</span>
            <span v-else>--</span>
          </div>
          <div class="info-con-item">
            <p>{{ $t('pay_slip_24') }}</p>
            <span v-if="payslipInfo.send_fail_count">{{
              Number(payslipInfo.send_fail_count) | ThousandSeparator
            }}</span>
            <span v-else>--</span>
          </div>
        </div>
      </div>
      <div class="content">
        <h1>{{ $t('pay_slip_25') }}</h1>
        <div class="select">
          <div class="select-content">
            <!-- 发放状态 -->
            <div class="select-state">
              <span>{{ $t('pay_slip_26') }}</span>
              <el-select v-model="query.send_status" size="small" @change="sentPayslipStaffList">
                <el-option :label="$t('91')" value="2"></el-option>
                <el-option :label="$t('818')" value="1"></el-option>
                <el-option :label="$t('error')" value="0"></el-option>
              </el-select>
            </div>
            <!-- 搜索 -->
            <div class="select-search">
              <el-input
                class="select-search-input"
                :placeholder="`${$t('22')}、${$t('25')}、${$t('825')}`"
                prefix-icon="el-icon-search"
                size="small"
                v-model="query.search_name"
              >
              </el-input>
            </div>
            <div>
              <el-button size="small" type="primary" @click="sentPayslipStaffList">{{ $t('69') }}</el-button>
            </div>
          </div>
          <!-- 下载失败、成功展示 -->
          <div class="select-send" v-if="!payState.state && Number(payslipInfo.is_afresh_count)">
            <span v-html="$t('pay_slip_44', { key: payslipInfo.is_afresh_count })"></span>
            <template v-if="$p('menu.payroll.scheme.edit')">
              ,<el-button type="text" @click="sendHandle">{{ $t('pay_slip_27') }}</el-button>
            </template>
          </div>
          <!-- 下载中展示 -->
          <div class="select-send" v-if="payState.state">Loading…</div>
        </div>
        <el-table :data="tableData" style="width: 100%">
          <!-- 姓名 -->
          <el-table-column prop="staff_name" :label="$t('22')" width="228px" />
          <!-- 手机号 -->
          <el-table-column prop="staff_phone" :label="$t('825')" width="150" />
          <!-- 工号 -->
          <el-table-column prop="staff_code" :label="$t('25')" width="130" />
          <!-- 发送状态 -->
          <el-table-column :label="$t('pay_slip_26')" min-width="130">
            <template slot-scope="scope">
              <p class="tab-state" v-if="scope.row.app_status">
                <i :class="Number(scope.row.app_status) ? 'el-icon-circle-check' : 'el-icon-circle-close'"></i>
                {{ $t('App') }}
              </p>
              <p class="tab-state" v-if="scope.row.email_status">
                <i :class="Number(scope.row.email_status) ? 'el-icon-circle-check' : 'el-icon-circle-close'"></i>
                {{ $t('personal_email') }}
              </p>
              <p class="tab-state" v-if="scope.row.exmail_status">
                <i :class="Number(scope.row.exmail_status) ? 'el-icon-circle-check' : 'el-icon-circle-close'"></i>
                {{ $t('business_mailbox') }}
              </p>
            </template>
          </el-table-column>
          <!-- 备注 -->
          <el-table-column prop="remark" :label="$t('remark')" min-width="130" />
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import {
  sentPayslipInfo, // 已经发送-payslip info
  getPayslipSentState,
  sentPayslipStaffList,
  afreshSendErrStaff, // 重新发送
  getAfreshSendStatus // 重新发送状态
} from '@/api/payroll/pay-slip'
export default {
  data() {
    return {
      // 筛选项
      query: {
        search_name: '', // 搜索名字
        send_status: '2', // 发送状态
        payslip_id: this.$route.params.id // 已发送数据id
      },
      payslipInfo: {
        name: '',
        send_count: '',
        send_fail_count: '',
        send_success_count: ''
      },
      clearTime: null, // 定时器
      payState: { state: null, is_self_task: null },
      tableData: []
    }
  },
  filters: {
    ThousandSeparator(input) {
      return input && input.toString().replace(/(^|\s)\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
    }
  },
  created() {
    // this.init()
    this.startTraining(true) // 当前数据状态
  },
  methods: {
    init() {
      sentPayslipInfo({ payslip_id: this.query.payslip_id }).then(res => {
        if (res && res.code === 1) this.payslipInfo = res.data.payslip_info
      })
      this.sentPayslipStaffList()
    },
    sentPayslipStaffList() {
      sentPayslipStaffList(this.query).then(res => {
        if (res && res.code === 1) this.tableData = res.data
      })
    },
    // 重新发送
    sendHandle() {
      afreshSendErrStaff({ payslip_id: this.query.payslip_id }).then(res => {
        if (res && res.code) {
          this.payState.state = 1
          this.tableData = []
          this.payslipInfo.send_fail_count = 0
          this.payslipInfo.send_success_count = 0
          const clearTime = null
          this.startTraining1(true, clearTime)
        }
      })
    },
    // 开始轮训
    startTraining1(type, clearTime) {
      if (!type) {
        // 为false 关闭定时器
        clearTimeout(clearTime)
        return
      }
      const this_ = this
      async function timerFn() {
        // 获取子项目状态
        getAfreshSendStatus({ payslip_id: this_.query.payslip_id })
          .then(res => {
            if (!res.data.state) clearTime = setTimeout(timerFn, 5000)
            else {
              this_.init()
              this_.payState.state = 0
              clearTimeout(clearTime)
            }
          })
          .catch(() => {
            this_.payState.state = 0
          })
      }
      timerFn()
    },
    startTraining(type) {
      // 开始轮训
      if (!type) {
        // 为false 关闭定时器
        return clearTimeout(this.clearTime)
      }
      const this_ = this
      async function timerFn() {
        // 获取子项目状态
        const res = await getPayslipSentState({ payslip_id: this_.query.payslip_id })
        if (res && res.code === 1) {
          this_.payState.state = Number(res.data.state)
          this_.payState.is_self_task = Number(res.data.is_self_task)
        }
        // state: 1,2为计算中状态 state为1停留在该页面接口一直请求 直到状态改为0
        if (this_.payState.state === 1) this_.clearTime = setTimeout(timerFn, 5000)
        if (!this_.payState.state) this_.init()
      }
      timerFn()
    },
    handlerBack() {
      const query = { active: this.$route.query.active }
      if (this.$route.query.month2) query.month2 = this.$route.query.month2
      if (this.$route.query.month3) query.month3 = this.$route.query.month3
      this.$router.push({
        path: '/payroll/pay-slip',
        query
      })
    }
  },
  beforeDestroy() {
    // 停止轮训
    this.startTraining(false)
    this.startTraining1(false)
  }
}
</script>

<style lang="scss" scoped>
.wrap1 {
  &-box {
    padding: 0 24px;
    .info {
      border-bottom: 1px solid #f0f0f0;
      padding: 40px 0 48px;
      text-align: center;
      .el-icon-success {
        font-size: 70px;
        color: #52c41a;
      }
      .el-icon-error {
        font-size: 70px;
        color: #f56c6c;
      }
      .icon {
        width: 72px;
        height: 72px;
      }
      .icon-wraing {
        line-height: 72px;
        border-radius: 50%;
        background: #fa8a14;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 15px;
        .sp {
          width: 24px;
          height: 24px;
          clear: both;
          margin: 0 auto;
        }
        .sp-3balls,
        .sp-3balls:before,
        .sp-3balls:after {
          border-radius: 50%;
          background-color: #fff;
          width: 10px;
          height: 10px;
          transform-origin: center center;
          display: inline-block;
        }
        .sp-3balls {
          position: relative;
          background: rgba(225, 225, 225, 1);
          animation: spScaleAlpha 1s infinite linear;
        }
        .sp-3balls::before,
        .sp-3balls::after {
          content: '';
          position: absolute;
          opacity: 0.25;
        }
        .sp-3balls:before {
          left: 18px;
          top: 0px;
          animation: spScaleAlphaBefore 1s infinite linear;
        }
        .sp-3balls::after {
          left: -18px;
          top: 0px;
          animation: spScaleAlphaAfter 1s infinite linear;
        }
      }
      h2 {
        font-size: 24px;
        color: #262626;
        margin: 16px 0;
      }
      p {
        font-size: 14px;
        color: #909399;
      }
      &-con {
        padding-top: 8px;
        display: flex;
        margin: 0 auto;
        justify-content: center;
        .info-con-item {
          flex: 1;
          background: #f6f7f8;
          border-radius: 4px;
          height: 118px;
          text-align: center;
          padding: 24px 0;
          &.center {
            margin: 0 24px;
          }
          p {
            font-size: 18px;
            color: #595959;
            padding-bottom: 12px;
          }
          span {
            font-size: 36px;
            color: #262626;
            font-weight: 600;
          }
        }
      }
    }
    .select {
      position: relative;
      padding-right: 260px;
      &-content {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
      }
      &-state {
        padding-bottom: 14px;
        display: inline-block;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.45);
        position: relative;
        span {
          height: 32px;
          line-height: 32px;
          color: #8c8c8c;
          position: absolute;
          left: 12px;
          z-index: 2;
        }
        .el-select {
          width: 260px;
        }
        /deep/ .el-input {
          min-width: 100%;
          .el-input__inner {
            padding-left: 110px;
          }
        }
      }
      &-search {
        padding-bottom: 14px;
        &-input {
          margin: 0 16px;
          min-width: 320px;
        }
        /deep/ span {
          display: flex;
          align-items: center;
        }
        img {
          width: 16px;
          margin-left: 4px;
        }
      }
      &-send {
        position: absolute;
        font-size: 14px;
        color: #8c8c8c;
        height: 32px;
        line-height: 32px;
        right: 0;
        top: 0;
        /deep/ .num {
          color: red;
        }
      }
    }
  }
}

.content {
  padding-top: 24px;
  padding-bottom: 15px;
  h1 {
    margin: 0;
    padding-bottom: 16px;
    display: flex;
    justify-content: space-between;
    span {
      font-size: 16px;
      color: #262626;
    }
    .some {
      img {
        width: 32px;
        vertical-align: middle;
        cursor: pointer;
      }
    }
  }
}
.tab-state {
  &:first-child {
    padding-top: 12px;
  }
  &:last-child {
    padding-bottom: 12px;
  }
  .el-icon-circle-check {
    color: green;
  }
  .el-icon-circle-close {
    color: red;
  }
}
.some-all {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .el-checkbox {
    display: block;
  }
  padding-bottom: 13px;
  border-bottom: 1px solid #f0f0f0;
}
.column-checkbox {
  padding-left: 3px;
  display: block;
  height: 34px;
  line-height: 34px;
}
@keyframes spScaleAlpha {
  0% {
    opacity: 1;
  }
  33% {
    opacity: 0.25;
  }
  66% {
    opacity: 0.25;
  }
  100% {
    opacity: 1;
  }
}
@keyframes spScaleAlphaBefore {
  0% {
    opacity: 0.25;
  }
  33% {
    opacity: 1;
  }
  66% {
    opacity: 0.25;
  }
}
@keyframes spScaleAlphaAfter {
  33% {
    opacity: 0.25;
  }
  66% {
    opacity: 1;
  }
  100% {
    opacity: 0.25;
  }
}
</style>
